import { MutationTree } from 'vuex';
import { writeSelectedLocations } from '@/utils/bulkSelection';
import { BulkEditState } from '../types';
import Vue from 'vue';

export const mutations: MutationTree<BulkEditState> = {
	SET_MENU_ROWS(state: BulkEditState, rows: BulkMenuItemRow[]): void {
		Vue.set(state, 'menuRows', rows);
	},

	SET_LOCATION_ROWS(state: BulkEditState, rows: BulkLocationRow[]): void {
		Vue.set(state, 'locationRows', rows);
	},

	SET_COUNT(state: BulkEditState, count: number): void {
		Vue.set(state, 'count', count);
	},

	SET_LOCATION_IDS(state: BulkEditState, locationIds: string[]): void {
		Vue.set(state, 'locationIds', locationIds);
		writeSelectedLocations(locationIds);
	}
};
